import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

export type Lang = 'ms' | 'en';

const STORAGE_KEY = 'serps_lang';

interface LangCtx {
  lang: Lang;
  setLang: (l: Lang) => void;
}

const Ctx = createContext<LangCtx>({ lang: 'ms', setLang: () => {} });

export function LangProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLangState] = useState<Lang>(() => {
    try { return (localStorage.getItem(STORAGE_KEY) as Lang) || 'ms'; }
    catch { return 'ms'; }
  });

  const setLang = useCallback((l: Lang) => {
    setLangState(l);
    try { localStorage.setItem(STORAGE_KEY, l); } catch {}
  }, []);

  // Sync <html lang> attribute for accessibility
  useEffect(() => {
    document.documentElement.lang = lang === 'en' ? 'en' : 'ms-BN';
  }, [lang]);

  return <Ctx.Provider value={{ lang, setLang }}>{children}</Ctx.Provider>;
}

export function useLang(): LangCtx { return useContext(Ctx); }
